"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const mui_1 = require("tss-react/mui");
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const utils_1 = require("utils/utils");
const styles_1 = __importStar(require("./styles"));
const useStyle = (0, mui_1.makeStyles)()(styles_1.default);
const EditableLabel = ({ value = '', revertOnEmpty = true, handleSubmit, style, overrideEditableLabel = false, variant = 'title', icon = null, readOnly = false, id, }) => {
    const [editing, setEditing] = (0, react_1.useState)(false);
    const [animate, setAnimate] = (0, react_1.useState)(false);
    const [valueState, setValueState] = (0, react_1.useState)(value);
    const animateEl = (0, react_1.useRef)(null);
    const isEnterKeyInvoked = (0, react_1.useRef)(false);
    const { classes } = useStyle();
    (0, react_1.useEffect)(() => {
        setValueState(value);
    }, [value]);
    (0, react_1.useEffect)(() => {
        if (animate) {
            (0, utils_1.addEventListenerOnce)(animateEl.current, 'animationend', () => {
                setAnimate(false);
            });
        }
    }, [animate]);
    const enableEditing = () => {
        setEditing(true);
    };
    const disableEditing = () => {
        setEditing(false);
    };
    const handleLabelClick = (event) => {
        enableEditing();
        event.stopPropagation();
    };
    const handleChange = (event) => {
        setValueState(event.target.value);
    };
    const handleFocus = (event) => {
        event.target.select();
    };
    const handleKeyDown = (event) => {
        if (event.key === 'Escape' || event.key === 'Esc') {
            disableEditing();
            setValueState(value);
        }
    };
    const handleSubmitFunc = () => {
        let valueUpdate = valueState;
        if (valueUpdate.length === 0 || !valueUpdate.trim()) {
            if (revertOnEmpty) {
                valueUpdate = value;
            }
            else {
                valueUpdate = '';
            }
        }
        disableEditing();
        if (handleSubmit) {
            handleSubmit(valueUpdate);
        }
        setAnimate(true);
    };
    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            isEnterKeyInvoked.current = true;
            handleSubmitFunc();
        }
    };
    return (<styles_1.Container ref={animateEl} className={(0, classnames_1.default)(editing ? classes.containerWhenEditing : classes.container, animate ? 'flash' : null)}>
      {(editing || overrideEditableLabel) ? (<TextField_1.default autoFocus className={classes.textField} classes={{ root: classes.input }} fullWidth onBlur={() => {
                if (!isEnterKeyInvoked.current) {
                    handleSubmitFunc();
                }
                isEnterKeyInvoked.current = false;
            }} onChange={handleChange} onFocus={handleFocus} onKeyDown={handleKeyDown} onKeyPress={handleKeyPress} value={valueState} InputProps={{
                classes: {
                    input: classes[variant],
                },
            }} style={style}/>) : (<>
          <input aria-hidden className={classes.inputForTabFocus} onFocus={enableEditing}/>
          <Typography_1.default className={(0, classnames_1.default)(classes.label, { [classes.readOnly]: readOnly }, { [classes.labelFlex]: icon })} onClick={(event) => (!readOnly && handleLabelClick(event))} 
        // @ts-expect-error: No overload matches this call.
        variant={variant}>
            {icon ? (<>
                <span id={id} className={classes.labelTextContainer}>{valueState}</span>
                {!readOnly && <span className={classes.iconContainer}>{icon}</span>}
              </>) : valueState}
          </Typography_1.default>
        </>)}
    </styles_1.Container>);
};
exports.default = EditableLabel;
